
    import Vue from 'vue';
    import {eventBus} from "@/services/event-bus";
    import SchedulerService from "@/services/scheduler.service";
    import SelectPatient from "@/components/SelectPatient.vue";
    import Period from "@/models/period";
    import PeriodPatientTherapiesList from "@/components/PeriodPatientTherpiesList.vue"
    import Patient from "@/models/patient";

    export default Vue.extend({
        props: {
            periodId: {type: Number, required: true}
        },
        components: {
            periodPatientTherpiesList: PeriodPatientTherapiesList,
            selectPatient: SelectPatient
        },
        watch: {
            periodId: function (val, oldVal) {
                if (val !== oldVal) {
                    this.loadPeriod();
                }
            }
        },
        computed: {
            model: {
                get(): any {
                    return this.period != null ? this.period.patients : [];
                },
                set(val: any) {
                    this.$emit('input', val);
                }
            }
        },
        mounted() {
            eventBus.$on('edit-patient', (item: Patient) => {
                this.editPatient(item)
            });
        },
        data() {
            return {
                selectPatientDialog: false,
                period: new Period({}),
                headers: [
                    {
                        text: 'Name',
                        value: 'name',
                    },
                    {
                        text: 'Surname',
                        value: 'surname',
                    },
                    {
                        text: 'Akcje',
                        value: 'actions',
                    },
                ],
                isFormValid: true,
                actions: [
                    {
                        color: 'info',
                        icon: 'mdi-account-edit',
                        action: (item: any) => {
                            // eslint-disable-next-line no-console
                            console.log(item);
                            eventBus.$emit('edit-patient', item);
                        }
                    },
                    {
                        color: 'red',
                        icon: 'mdi-delete-forever',
                        action: (item: any) => {
                            // eslint-disable-next-line no-console
                            console.log("row click delete-therapy:" + item.id);
                            eventBus.$emit('delete-patient', item);
                            //todo: dodanie obsługi kasowania
                        }
                    },
                ],
                activator: null,
                attach: null,
                editing: null,
                index: -1,
                patient: null,
                menu: false,
                x: 0,
                search: null,
                y: 0,
            }
        },

        methods: {
            edit(index: any, item: any) {
                if (!this.editing) {
                    this.editing = item;
                    this.index = index
                } else {
                    this.editing = null;
                    this.index = -1
                }
            },
            filter(item: any, queryText: string, itemText: string) {
                if (item.header) return false;

                const hasValue = (val: string) => val != null ? val : '';

                const text = hasValue(itemText);
                const query = hasValue(queryText);

                return text.toString()
                    .toLowerCase()
                    .indexOf(query.toString().toLowerCase()) > -1
            },
            hideMenu() {
                this.$router.push('/periods');
            },
            toLabel(item: any): string {
                return `${item.name} ${item.surname}`;
            },
            editPatient(item: any) {
                this.patient = item
            },
            loadPeriod() {
                SchedulerService.period(this.periodId).then((e: any) => this.period = new Period(e))
            },
            hideSelectPatientForm() {
                this.loadPeriod();
                this.selectPatientDialog = false;
            },
        },
        created() {
            // PartyService.allPatients().then(p => this.items = p).catch(e => eventBus.$emit('error', e.message))
            this.loadPeriod();
            eventBus.$on('hidePatientDialog', () => {
                this.selectPatientDialog = false;
            })
            eventBus.$on('updatePeriod', () => {
                this.loadPeriod();
            })
        }
    });
